/**
 * Единый ключ для сравнения _id / parentId в TreeTable, когда в метаданных колонка Text или Identificator

 */
export function canonicalTreeNodeId(value: unknown): string {
  if (value === undefined || value === null) return ''
  if (typeof value === 'bigint') return String(value)
  if (typeof value === 'number' && Number.isFinite(value)) {
    return String(Math.trunc(value))
  }
  const raw =
    typeof value === 'object' && value !== null && 'value' in (value as object)
      ? (value as { value: unknown }).value
      : value
  if (typeof raw === 'bigint') return String(raw)
  if (typeof raw === 'number' && Number.isFinite(raw)) {
    return String(Math.trunc(raw))
  }
  const s = String(raw).trim()
  if (s === '') return ''
  if (/^-?\d+(\.\d+)?([eE][+-]?\d+)?$/.test(s)) {
    const n = Number(s)
    if (Number.isFinite(n)) return String(Math.trunc(n))
  }
  return s
}

export function treeNodeIdsEqual(a: unknown, b: unknown): boolean {
  return canonicalTreeNodeId(a) === canonicalTreeNodeId(b)
}

// Пустой слот в составном ключе TreeTable 
export const TREE_TABLE_UNIQUE_EMPTY_SLOT = '\uE000'

// Неперечислимое поле на `data` строки TreeTable для сопоставления узла
export const TREE_TABLE_NODE_KEY_FIELD = '__treeTableNodeKey' as const

export function attachTreeTableNodeKey(data: object, key: string): void {
  Object.defineProperty(data, TREE_TABLE_NODE_KEY_FIELD, {
    value: key,
    enumerable: false,
    configurable: true,
  })
}
